import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    COMMODITIES_REMOVE,
    COMMODITIES_SET,
    COMMODITY_CREATE_FAILED,
    COMMODITY_CREATE_REQUESTED,
    COMMODITY_CREATE_SUCCEEDED,
    COMMODITY_DELETE_FAILED,
    COMMODITY_DELETE_REQUESTED,
    COMMODITY_DELETE_SUCCEEDED,
    COMMODITY_UPDATE_FAILED,
    COMMODITY_UPDATE_REQUESTED,
    COMMODITY_UPDATE_SUCCEEDED
} from './constants';

// Types
import {
    CommoditiesState,
    Commodity,
    CommodityCreatePayload,
    CommodityDeletePayload,
    CommodityUpdatePayload,
    FailedCreateCommodityAction,
    FailedDeleteCommodityAction,
    FailedUpdateCommodityAction,
    RemoveCommoditiesAction,
    RequestCommodityUpdateAction,
    RequestCreateCommodityAction,
    RequestDeleteCommodityAction,
    SetCommoditiesAction,
    SucceededCommodityUpdateAction,
    SucceededCreateCommodityAction,
    SucceededDeleteCommodityAction
} from './types';

export function requestCreateCommodity(
    payload: CommodityCreatePayload
): RequestCreateCommodityAction {
    return {
        type: COMMODITY_CREATE_REQUESTED,
        payload
    };
}

export function succeededCreateCommodity(
    response: AxiosResponse
): SucceededCreateCommodityAction {
    return {
        type: COMMODITY_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateCommodity(
    error: AxiosError
): FailedCreateCommodityAction {
    return {
        type: COMMODITY_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateCommodity(
    payload: CommodityUpdatePayload
): RequestCommodityUpdateAction {
    return {
        type: COMMODITY_UPDATE_REQUESTED,
        payload
    };
}

export function succeededUpdateCommodity(
    response: AxiosResponse
): SucceededCommodityUpdateAction {
    return {
        type: COMMODITY_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateCommodity(
    error: AxiosError
): FailedUpdateCommodityAction {
    return {
        type: COMMODITY_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestDeleteCommodity(
    payload: CommodityDeletePayload
): RequestDeleteCommodityAction {
    return {
        type: COMMODITY_DELETE_REQUESTED,
        payload
    };
}

export function succeededDeleteCommodity(
    response: AxiosResponse
): SucceededDeleteCommodityAction {
    return {
        type: COMMODITY_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteCommodity(
    error: AxiosError
): FailedDeleteCommodityAction {
    return {
        type: COMMODITY_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function removeCommodities(
    ids: Commodity['id'][]
): RemoveCommoditiesAction {
    return {
        type: COMMODITIES_REMOVE,
        payload: {
            ids
        }
    };
}

export function setCommodities(
    commodities: CommoditiesState
): SetCommoditiesAction {
    return {
        type: COMMODITIES_SET,
        payload: commodities
    };
}
